import Eye from '@/assets/icons/Eye.svg';
import * as Styled from './LookInside.styled';

interface LookInsideProps {
  url: string;
}

export const LookInside = ({ url }: LookInsideProps) => {
  return (
    <Styled.Selector data-jb-modal href={url}>
      <span>Look inside</span>
      <Eye />
    </Styled.Selector>
  );
};
